import moment from "moment";
import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import CustomPagination from "../../../components/Common/CustomPagination";
import HotelAdminFilter from "../../../components/Common/HotelAdminFilter";
import TableActions from "../../../components/Common/TableActions";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import TableLayout from "../../../components/TableLayout";
import dataHandler from "../../../hooks/dataHandler";
import {
  DELETESERVICECATEGORY,
  HOTELADMIN,
  HOTELADMINDELETE
} from "../../../services/ApiCalls";

import { useTranslation } from "react-i18next";
import AdminUserStat from "../../../components/Common/AdminUserStat";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import { activeInactiveOptions } from "../../../utilities/const";
import {
  exportCsvHandler
} from "../../../utilities/utilities";

const ManageHotelAdmin = () => {
  const [exportLoader, setExportLoader] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  const {
    setBody,
    body,
    data,
    statusChangeHandler,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: HOTELADMIN,
  });

  const columns = [
    {
      head: t("manageHotelAdmin.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => <>{body.limit * (body.page - 1) + key + 1}</>,
    },
    {
      head: t("manageHotelAdmin.columns.name"),
      accessor: "name",
      component: (item) => (
        <>{item?.name || t("manageHotelAdmin.placeholders.notAvailable")}</>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.address"),
      accessor: "address",
      component: (item) => {
        const words = item?.address?.split(" ");
        const truncatedText = words?.slice(0, 4).join(" ");
        const displayText =
          words?.length > 4
            ? `${truncatedText}...`
            : truncatedText || t("manageHotelAdmin.placeholders.notAvailable");
        return (
          <span
            title={item?.address}
            className="text-nowrap d-inline-block"
            style={{ maxWidth: "150px" }}
          >
            {displayText}
          </span>
        );
      },
    },
    {
      head: t("manageHotelAdmin.columns.mobileNumber"),
      accessor: "mobileNumber",
      component: (item) => (
        <span className="text-nowrap">
          {item?.countryCode
            ? `+${item.countryCode} ${item.mobileNumber}`
            : item?.mobileNumber ||
              t("manageHotelAdmin.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.email"),
      accessor: "email",
      component: (item) => (
        <span
          className="d-inline-block text-truncate"
          title={item?.email}
          style={{ maxWidth: "180px", verticalAlign: "middle" }}
        >
          {item?.email || t("manageHotelAdmin.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.avgRating"),
      accessor: "avgRating",
      component: (item) => (
        <span className="d-flex justify-content-center align-items-center">
          {item?.avgRating || t("manageHotelAdmin.placeholders.zero")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.accountCreatedAt"),
      accessor: "createdAt",
      component: (item) => (
        <span style={{ color: "#E8307A", fontWeight: "500" }}>
          {item.createdAt
            ? moment(item.createdAt).format("MM-DD-YYYY , HH:mm")
            : t("manageHotelAdmin.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.numberOfHotels"),
      accessor: "totalHotels",
      component: (item) => (
        <span className="d-flex justify-content-center align-items-center">{item?.totalHotels || t("manageHotelAdmin.placeholders.zero")}</span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.status"),
      accessor: "status",
      title: t("manageHotelAdmin.statusTooltip"),
      component: (item) => (
        <span
          className={`fw-semibold ${
            item?.isVarified
              ? "text-success"
              : "text-danger"
          }`}
        >
          {item?.isVarified?"Verified":"Not Verified" || t("manageHotelAdmin.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          viewLink={`/manage-hotel-admin/detail/${item._id}?page=${body.page}`}
          editUrl={`/manage-hotel-admin/edit/${item._id}?page=${body.page}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={() =>
          deleteHandler(() =>
            DELETESERVICECATEGORY({ _id: deleteModel.dumpId })
          )
        }
      />
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() => HOTELADMINDELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="manageServiceCategory py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0  fw-bold text-dark text-capitalize">
                  {t("manageHotelAdmin.title")}
                </h4>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("hoteladmin", setExportLoader)
                        }
                      >
                        {exportLoader ? (
                          <ButtonLoader />
                        ) : (
                          t("manageHotelAdmin.buttons.exportCsv")
                        )}
                      </Button>
                    </li>
                    <li className="">
                      <Link
                        to="/manage-hotel-admin/add"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        {t("manageHotelAdmin.buttons.addNewHotelAdmin")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="">
              <AdminUserStat platform={data?.platform} type="adminuser" />
            </Col>

            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <HotelAdminFilter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout
                column={columns}
                data={data?.ownerList}
                loader={loader}
              />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageHotelAdmin;
